/* eslint-disable */
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import '~styles/modules/featureformat.scss';

const FeatureFormat = ({ data }) => {

  //Build image + title container
  const ImageTitle = data.map((item) => {

  	//If it's archieJSON  it's the archie part of combo, otherwise it's the body element (in this case always text)
  	if (item.archieJson){
  		const archieObj = JSON.parse(item.archieJson)
  		return (
			<div>
	  			<div className="col-images">
	  				<a href={archieObj.url}><img className="feature-images" src={archieObj.image} /></a>
	  			</div>
	  			<h2 className="feature-titles col-titles"><a href={archieObj.url}>{archieObj.title}</a></h2>
	  		</div>
  		)

  	};

  });

  //Build description
  const description = data.map((item) => {
  	if (!item.archieJson){
  		if (item.type=='text'){
	  		return (
	  			<p className="paragraph">
	  			  {ReactHtmlParser(item.content)}
	  			</p>
	  		)
  		}
  	}
  });

  //Combine image, title, description
  return (
	<div className="feature-containers">
		{ImageTitle}
		{description}
   </div>
  );
};

export default FeatureFormat;
